import {bindable} from 'aurelia-framework';

export class Toggle {
  @bindable leftLabel = 'Excel';
  @bindable rightLabel = 'CSV';
  @bindable value;

  toggle() {
    this.value = (this.value === this.leftLabel) ? this.rightLabel : this.leftLabel;
  }

  attached() {
    if (this.value !== this.leftLabel && this.value !== this.rightLabel) {
      this.value = this.leftLabel;
    }
  }
}
